import React, { useState } from 'react';

import '../../../static/css/main.css'
import '../../../static/css/animate.css'
import '../../../static/fonts/stylesheet.css'
import { useDispatch, useSelector } from 'react-redux';
import { selectTypeObject, setTypeObject } from '../../calc/calcSlice';
import { TYPES_OBJECTS } from '../../../static/vars';
import { setShowPopUpManager } from '../../home/homeSlice';




export function DropDownObject(props) {
    const dispatch = useDispatch()

    const typeObject = useSelector(selectTypeObject)

    const [showDropDown, setShowDropDown] = useState(false);

    const handleClickDropDown = () => {
        console.log('handleClickDropDown')
        setShowDropDown(!showDropDown)
    }

    function handleClickObject(index) {
        props.setIsChangeParams(true)
        dispatch(setTypeObject(TYPES_OBJECTS[index].text))
        setShowDropDown(false)
        if (index !== 0 && index !== 3) dispatch(setShowPopUpManager(true))
    }

    return (
        <div class="form-1-col form-1-col-1">
            <div class="form-group">
                <div class="dropdown hint3">
                    <label for="select-1">Тип объекта</label>
                    <button onClick={handleClickDropDown} class="dropdown__button">{typeObject}</button>
                    {showDropDown &&
                        <ul class="dropdown__list">
                            {
                                TYPES_OBJECTS.map((object, index) => {
                                    return (
                                        <li 
                                            key={index} 
                                            class="dropdown__list-item"
                                            onClick={() => handleClickObject(index)}
                                        >
                                            {object.text}<span>{object.comment}</span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    }
                    <input type="text" name="select-category" value=""
                        class="dropdown__input-hidden" />
                </div>
            </div>
        </div>
    );
}



